import styled from 'styled-components';
import { Container, getToken } from '@optimus-web/core';

export const ContainerStyled = styled(Container)`
    border: ${getToken('borderWidth100')}px solid ${getToken('borderStaticPrimary')};
    border-radius: ${getToken('borderRadius100')}px;
`;
